import '../assets/NcActionButtonGroup-ChehtUip.css';
import { defineComponent as t } from "vue";
import { G as r } from "./GenRandomId-BW3iYFf9.mjs";
import { r as a, a as o } from "./_l10n-BaNxGGXy.mjs";
import { n as s } from "./_plugin-vue2_normalizer-Bj5bLKV4.mjs";
a();
const i = t({
  name: "NcActionButtonGroup",
  inject: {
    isInSemanticMenu: {
      from: "NcActions:isSemanticMenu",
      default: !1
    }
  },
  props: {
    /**
     * Optional text shown below the button group
     */
    name: {
      required: !1,
      default: void 0,
      type: String
    }
  },
  setup() {
    return {
      labelId: "nc-action-button-group-".concat(r())
    };
  },
  methods: {
    t: o
  }
});
var l = function() {
  var e = this, n = e._self._c;
  return e._self._setupProxy, n("li", { staticClass: "nc-button-group-base", attrs: { role: e.isInSemanticMenu && "presentation" } }, [e.name ? n("div", { attrs: { id: e.labelId } }, [e._v(" " + e._s(e.name) + " ")]) : e._e(), n("ul", { staticClass: "nc-button-group-content", attrs: { role: "group", "aria-labelledby": e.name ? e.labelId : void 0 } }, [e._t("default")], 2)]);
}, u = [], c = /* @__PURE__ */ s(
  i,
  l,
  u,
  !1,
  null,
  null,
  null,
  null
);
const b = c.exports;
export {
  b as N
};
